import React from "react";
import moment from 'moment';
import { Link,Redirect } from "react-router-dom";
import {getData} from '../../../../services/index';
import { Tabs ,Modal,Select,Button} from 'antd';
import { StickyContainer, Sticky } from 'react-sticky';
import 'antd/dist/antd.css';

import { PlusOutlined,MoreOutlined,FieldTimeOutlined,EditOutlined } from '@ant-design/icons';

import add from '../../../../assets/images/icon/add.png';

const { TabPane } = Tabs;
const { Option } = Select;
class Index extends React.Component {
	static contextTypes = {
        router: () => null
    };
	constructor(props) {
		super(props);
		this.state = {
			loading: false,
			visible: false,
			tab: 'Mandatory',
			values: [1],
			package_list: [],
		}
		
	}

	componentWillMount() {
		document.querySelector(".loader-wrapper").style = "display: none";
		setTimeout(() => {
			document.querySelector(".loader-wrapper").style = "display: none";
		}, 500);
		if(!localStorage.getItem('schoolData')) {
			localStorage.setItem("schoolData",'');
			localStorage.clear();
			window.location.href = '/login';
		}else{
		var storedArray = JSON.parse(localStorage.getItem("schoolData"))
		setTimeout(() => {
		  this.setState({ user_id : storedArray['data'][0]['user_id'],program_id : this.props.match.params.id,school_id : storedArray['data'][0]['school_id'],tab:this.props.match.params.text });
		}, 100);
		
		}
		
		setTimeout(() => {
		  this.checkData();
		}, 100);
		
	}
	
	
	checkData(){
  	    if(localStorage.getItem('schoolData')){
			var storedArray = JSON.parse(localStorage.getItem("schoolData"));
			var user_id = storedArray['data'][0]['user_id'];
			var school_id = storedArray['data'][0]['school_id'];
			var app = {school_id : school_id,user_id:user_id,type:this.state.tab}
			getData('fees/manage_package_list',app).then((result) => {
				let responseJson = result;
				if(responseJson.data){
					if(result['status'] == 200){
						this.setState({
							package_list: result['data'],
							total_count: result['total_count'],
						});
					}else{
						this.setState({
							package_list: [],
							total_count: 0,
						});
					}
				}
			});	
			
				
			
	}
  }
	
	showModal = () => {
		this.setState({
		  visible: true,
		});
	  };

	  handleOk = () => {
		this.setState({ loading: true });
		setTimeout(() => {
		  this.setState({ loading: false, visible: false });
		}, 3000);
	  };

	  handleCancel = () => {
		this.setState({ visible: false });
	  };
	  
	handleSizeChange = e => {		
		this.setState({ [e.target.name]: e.target.value });		
		
	 };  
		
	showMenu= (id, e) =>  {
		e.preventDefault();
		if(this.state.showMenu == 1){
			document.getElementById('open_action_' + id).classList.remove('is-active');
			this.setState({
			  showMenu: 0,
			});
		}else{
			document.getElementById('open_action_' + id).classList.add('is-active');
			this.setState({
			  showMenu: 1,
			});
		}
		
		
	}

	handletabchange=(e)=>{
			this.setState({
					tab: e,
				});
			setTimeout(() => {
				this.checkData();
			}, 100);
	}	
	
	

	render() {
	
	const { visible, loading } = this.state;	
		return (
			<div class="mobile_view">
			
			
      
      <div id="main">		
         <div class="row">
		 
		 <div class="col s12 m12 ex-padd">
            <div id="breadcrumbs-wrapper" class="bg-off">
               <div class="">
                  <div class="row no-margin">
				  <div class="col s12 m12 header-title mt-20 mh-40 iq-card">
                     <div class="col s12 m6 l6 pb-15 mt-5">
                        <h5 class="breadcrumbs-title"><span class="back_arrow" onClick={this.context.router.history.goBack}><i class="ri-arrow-left-circle-line"></i></span><span class="main_title">Manage Fees Package</span></h5>
                     </div>
                     <div class="col s12 m6 l6 right-align-md pt-10">
                        <ol class="breadcrumbs mb-0">
                           <li class="breadcrumb-item"><a href="/">Home</a>
                           </li>
                           
						   <li class="breadcrumb-item "><a href="/settings/fees">Fees Setting</a>
                           </li>
						   <li class="breadcrumb-item active">Manage Fees Package
                           </li>
                        </ol>
                     </div>
                     </div>
                  </div>
               </div>
            </div>
            </div>
		 
		 
			<div class="col col-md-12  ex-padd">
               <div class="container ">
				<div class="">
                  <section class="section no-padd">
                    <div class="responsive-table iq-card bg-shadow-none">
					
					<div class="desktop-view"> 
					
					<ul class="nav nav-tabs" role="tablist">
						<li class="nav-item ">
							<a  class="nav-link active" className={`nav-link  ${this.state.tab == 'Mandatory'?'active':''}`} onClick={this.handletabchange.bind(this,'Mandatory')}>Mandatory</a>
						</li>
						
						<li class="nav-item">
							<a class="nav-link" className={`nav-link  ${this.state.tab == 'Optional'?'active':''}`} onClick={this.handletabchange.bind(this,'Optional')}>Optional</a>
						</li>
						
						<li class="nav-item">
							<a class="nav-link " className={`nav-link  ${this.state.tab == 'Others'?'active':''}`} onClick={this.handletabchange.bind(this,'Others')}>Others</a>
						</li>
					</ul>
					
					
					 
					
					 
                    <div class="dataTables_wrapper no-footer mh-500 ">
                         <div class="top display-flex flow-root ">
							<div class="actions action-btns display-block align-items-center col col-md-12  right hidden-xs no-padd">
							  
								<Link class="right" to={`${process.env.PUBLIC_URL}/settings/fees/fees_package/manage_add/${this.state.tab}`}>							 
								 <button className="action_btn mt-5"><PlusOutlined /> Add New</button>
								 </Link>	
							  
								 
                            </div>
						</div>
						
						<div class={`col m12 s12 `}>
								<table class="cust_table">
								  <thead>
									<tr>
										<th class="">Sr. No</th>
										<th class="">Academic Year</th>
										<th>Package Name</th>
										<th>Total Amount</th>
										<th>Action</th>
									</tr>
								  </thead>

									<tbody>
									{this.state.package_list.map((list)=> ( 
										<tr>
											<td>{list.sr_no}</td>
											<td>{list.academic_year}</td>
											<td>{list.package_name}</td>
											<td>{list.total_amount}</td>
											<td>
												<div class="invoice-action">
													<button class="action-btn pl-10" onClick={this.showMenu.bind(this,list.id)}>
														<MoreOutlined />
													</button>
													<div className="action-menu" id={`open_action_${list.id}`}>					
														<Link to={`${process.env.PUBLIC_URL}/settings/fees/fees_package/manage_edit/${list.id}`}><li> <EditOutlined />View & Edit </li>
														</Link>						
													</div>
												</div>							
											</td>
										</tr> 
									))}	
											
									{(() => {  
									if (this.state.package_list.length =='0') {
											return (
														<td id="error" class="center" colspan="5">No Data Found</td>
													)
											}
									})()}	
																
												
									</tbody>
								</table>
						</div>	
						
						
						
						
				
                    </div>
				</div>
				
				<div class="mobile-view">	
				<div class="col s12 m12 ex-padd ">
								<div id="main" class="bg-off">
									<div class="row">
									<div class="container">
										
											<div class="mobile-tab">
												<div  className={`mobile-tab-view min-w-33 ${this.state.tab == 'Mandatory'?'':'tab-none'} `}  onClick={this.handletabchange.bind(this,'Mandatory')}>	Mandatory </div>	
												<div  className={`mobile-tab-view min-w-33 ${this.state.tab == 'Optional'?'':'tab-none'} `}  onClick={this.handletabchange.bind(this,'Optional')}>	Optional </div>	
												<div  className={`mobile-tab-view min-w-33 ${this.state.tab == 'Others'?'':'tab-none'} `}  onClick={this.handletabchange.bind(this,'Others')}>	Others </div>	
												
											</div>
										
									</div>
									</div>
								</div>
							</div>
							
				<div class="mt-50">
				<div class="children bg-blue tags iq-card2 flow-root">
					{this.state.package_list.map((list) => (
											<Link to={`${process.env.PUBLIC_URL}/settings/fees/fees_package/manage_edit/${list.id}`}>
												<div class="col m12 s12 mb-10 bb pb-10 tag-div">
														<div class="col m10 s12 ">
															{list.package_name}
														</div>
														
												</div>
											</Link>
					))}
					
					{(() => {  
												if (this.state.package_list.length =='0') {
													return (
														<p id="error" class="center mt-20">No Data Found</p>
													)
												}
											})()}	
					
				</div>
				</div>
				
				<div class="notice-left">
							<Link to={`${process.env.PUBLIC_URL}/settings/fees/fees_package/manage_add/${this.state.tab}`}><img src={add} /></Link>
						</div>
						
			</div>	
						
						
                     </div>
                  </section>
               </div>
               </div>
               <div class="content-overlay"></div>
            </div>	
			
			
			
			
			
			
            <div class="content-overlay"></div>       
      </div>
      </div>
     

			</div>
		) 
	} 
}
export default Index;
